import * as IoC from 'typescript-ioc';
import { JobConfiguration } from '../../job-configuration';
import { JobType } from '../../../../api/jobs.dao';
import { IMeetingsDAO } from '../../../../api/meetings.dao';

export class AssignMeetingsToRoomsJob extends JobConfiguration {
    public readonly type = JobType.AssignRooms;
    public readonly name = 'Assign Rooms';
    public readonly description = 'Rooms Assignment';

    public async execute(execParams) {
        return IoC.Container.get(IMeetingsDAO).assignRooms(execParams);
    }
}

export default {
    [JobType.AssignRooms]: AssignMeetingsToRoomsJob
};
